module.exports = __webpack_public_path__ + "static/media/Accommodation_Process.5195b636.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/links/Accommodation_Process.pdf
// module id = 287
// module chunks = 0